// extracted by mini-css-extract-plugin
export default {"container":"Favoutites_container__MyYJe","img":"Favoutites_img__0DeMS"};